import style from "./P.module.css";
import clsx from "classnames";

function P(props) {
    const { weight, font, size, i, min, marginBottom, color, gradient1,gradient2, gradientTextBlack } = props;
    return (
        <p 
        className={clsx(props.className, {[style.gradient1] : gradient1}, {[style.gradient2] : gradient2}, {[style.gradientTextBlack] : gradientTextBlack})}
        style={{
            fontWeight: weight,
            fontFamily: font,
            fontSize: props.min ? `max(${size}, ${min})` : size,
            fontStyle: props.i ? "italic" : "normal",
            color: color,
            marginBottom: props.marginBottom,
            textAlign: props.textAlign ? props.textAlign : "center",
            whiteSpace: "pre-wrap",
            letterSpacing: props.letterSpacing ? props.letterSpacing : null,
            opacity: props.opacity ? props.opacity : null,
            lineHeight: props.lineHeight ? props.lineHeight : null,
            backgroundColor: props.backgroundColor ? props.backgroundColor : null,
            background: props.background ? props.background : null,
            padding: props.padding ? props.padding : null,
            cursor: props.cursor ? "pointer" : null,
            textShadow: props.textShadow ? props.textShadow : null,
            textDecoration: props.textDecoration ? props.textDecoration : null,
            textDecorationColor: props.textDecorationColor ? props.textDecorationColor : null,
            wordBreak: props.wordBreak ? props.wordBreak : null,
        }} onClick={props.onClick}>
            {props.children}
        </p>
    );
}

export default P;